module.exports = __webpack_public_path__ + "img/cassandra.55bc873b.svg";